<template lang='pug'>
.dot-container( :class='showingState' ref='container' @mouseleave='setHideTimeout' @mouseenter='clearHideTimeout' )
	.icon-more.icon-more_menu(@click='expand')
	.menu( ref='menu' )
		.title Options
		.menu-option(@click='toggleStatus( row )') {{ rowStatus }}
		.menu-option(@click='forgotPass( row.email )') Send Password Reset Email
		.menu-option(@click='edit( row )') Edit
</template>

<script>
import Submit from '@/lib/Submit';
import { PasswordReset } from '@/lib/db/auth';
import { clone } from '@/lib/utils';

export default {
	name : 'user-table-menu',

	props : {
		column : {
			type : Object,
		},

		row : {
			type : Object,
		}
	},

	data : () => ( {
		showingState : 'hidden',
		hideTimeout  : null,
	} ),

	computed : {
		rowStatus() {
			return ( this.row.status === 'Enabled' ) ? 'Disable' : 'Enable';
		},
	},

	methods : {

		expand() {
			this.showingState = 'active';
		},

		setHideTimeout() {
			this.hideTimeout = window.setTimeout( () => {
				this.showingState = 'hidden';
			}, 500 );
		},

		clearHideTimeout() {
			if ( this.hideTimeout ) {
				window.clearTimeout( this.hideTimeout );
			}
		},

		toggleStatus( user ) {
			const { usersKey, status } = user;

			const result = ( status === 'Enabled' ) ? 'Disabled' : 'Enabled';

			const newUser = {
				status : result,
			};

			Submit.editUser( newUser, usersKey );
		},

		forgotPass( email ) {

			PasswordReset( email )
				.then( () => {
					// eslint-disable-next-line no-alert
					alert( 'Email has been sent.' );
				} )
				.catch( ( error ) => {
					// An error happened.
					console.error( error );
				} );

		},

		edit( user ) {
			const formUser = clone( user );

			switch ( user.permissionLevel ) {

				case 'Read Only': {
					formUser.permissionLevel = 1;
					break;
				}

				case 'Read and Write': {
					formUser.permissionLevel = 2;
					break;
				}

				case 'Read, Write, and Admin': {
					formUser.permissionLevel = 3;
					break;
				}

				default: {
					break;
				}
			}

			this.$store.dispatch( 'form', {
				type         : 'user',
				args         : [{ edit : true }],
				startingData : formUser,
			} )
				.then( ( form ) => {
					Submit.editUser( form.value, user.usersKey );

					form.close();
				} );
		},
	}
};
</script>

<style lang='scss'>
.dot-container {
	position: absolute;
	top: 0;
	right: 15px;
	padding: 14px 20px;
	border-radius: 15px;
	color: $color-primary;
	opacity: 1;
	min-width: 240px;
	min-height: 130px;
	transition: .2s ease-in-out;

	&.active {
		background-color: white;
		box-shadow: $defaultBoxShadow;
		z-index: 3;

		.icon-more_menu {
			pointer-events: none;
		}

		.menu {
			opacity: 1!important;
			z-index: 2;
			pointer-events: all;
		}
	}

	&:hover {
		cursor: default;
	}

	.icon-more_menu {
		font-size: 20px;
		position: relative;
		display: block;
		float: right;
		text-align: right;
		z-index: 2;
		padding: 0 5px;
		margin-top: -2.5px;
		transform: translateX(10px);

		&:hover {
			cursor: pointer;
		}
	}


	.menu {
		opacity:0;
		pointer-events: none;
		z-index: -1;

		.menu-option {
			margin: 4% 0;
			color: $blueGrey;

			&:hover {
				cursor: pointer;
			}
		}
	}
}
</style>
